export default {
    sitePlaces: [],
};



// WEBPACK FOOTER //
// ./src/store/modules/sitePlace/state.js